import { Box, Typography } from "@material-ui/core";
import React from "react";
import ListingLayout from "../../Components/UI/ListingLayout";
import { useStyles } from "./style";
import Form from "./Form";
import textStyle from "../../style/typography";

const title = {
  ROSTER: `Roster`,
  SURVEY: `Survey`,
  LEAVE: `Leave`,
  TIMESHEET: `Timesheet`,
  DISCREPANCY: `Discrepancy`,
  EMPLOYEES: `Employee`,
  ROSTERROLES: `Roles`,
  BUDGET: `Budget`,
  EMPLOYEEUSER: `Users`,
  ENQUIRIES: `Enquiries`,
};

const priceConfig = {
  ROSTER: `40`,
  SURVEY: `20`,
  LEAVE: `20`,
  TIMESHEET: `40`,
  DISCREPANCY: `10`,
  EMPLOYEES: `15`,
  ROSTERROLES: `15`,
  BUDGET: `30`,
  EMPLOYEEUSER: `20`,
  ENQUIRIES: `30`,
};

const Landing = ({ item }) => {
  const classes = useStyles();
  const textClasses = textStyle();

  let componentToRender = item.replaceAll("-", "");

  return (
    <ListingLayout hideAdd={true} hasFilter={false} showLocationToggle={true}>
      <Box className={classes.container}>
        <Box className={classes.card}>
          <Typography className={textClasses.header2}>
            You’re not subscribed to {title[componentToRender]}. Access it for
            just €{priceConfig[componentToRender]}/month .
          </Typography>

          <Form component={componentToRender} />
        </Box>
      </Box>
    </ListingLayout>
  );
};

export default Landing;
